export const NAME = "page-reset-password";

export const RESET_PASSWORD_FORM = `${NAME}/RESET_PASSWORD_FORM`;
